import { IPortInInformation } from "../interface/IPortIn";

export interface IPortInInformationResponse {
    direction: string;
    mnpId: number;
    otherNetworkAccountNumber: string;
    otherNetworkId: number;
    otherNetworkName: string;
    phoneNumber: string;
    portStartDateTime: string;
    rejectCode: string;
    serviceId: number;
    state: string;
    status: string;
    type: string;
}

export const getResponseToState = (response: IPortInInformationResponse): IPortInInformation => ({
    direction: response.direction,
    mnpId: response.mnpId,
    otherNetworkAccountNumber: response.otherNetworkAccountNumber,
    otherNetworkId: response.otherNetworkId,
    otherNetworkName: response.otherNetworkName,
    phoneNumber: response.phoneNumber,
    portStartDateTime: response.portStartDateTime,
    rejectCode: response.rejectCode,
    serviceId: response.serviceId,
    state: response.state,
    status: response.status,
    type: response.type,
});
